import React from 'react';
import bgImage from '../assets/images/background/faq-one-bg.png';
import { graphql, useStaticQuery } from 'gatsby';
import Accordians from './Accordians';

const Faq = () => {
  const data = useStaticQuery(graphql`
    {
      strapiHomePage {
        faq_heading
      }
    }
  `);

  const {
    strapiHomePage: { faq_heading },
  } = data;

  return (
    <section className='faq-one' id='faq'>
      <img src={bgImage} alt='alter text' className='faq-one__bg' />
      <div className='container'>
        <div className='block-title text-center'>
          <h2 className='block-title__title'>{faq_heading}</h2>
        </div>
        <Accordians />
      </div>
    </section>
  );
};
export default Faq;
